import React from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { formatDateTime } from "@/lib/format";

export default function NotificationBell() {
  const [count, setCount] = React.useState(0);
  const [items, setItems] = React.useState([]);
  const nav = useNavigate();

  const refresh = React.useCallback(async () => {
    try {
      const [c, l] = await Promise.all([api.get("/notifications/unread-count"), api.get("/notifications")]);
      setCount(c.data.count || 0);
      setItems(l.data.slice(0, 8));
    } catch {}
  }, []);

  React.useEffect(() => {
    refresh();
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [refresh]);

  const markAll = async () => {
    try { await api.post("/notifications/read-all"); refresh(); } catch {}
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="relative rounded-full p-1.5 hover:bg-neutral-100 transition-colors" data-testid="notif-bell">
          <Bell className="h-4 w-4 text-neutral-700" />
          {count > 0 && (
            <span className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-green-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="notif-count">
              {count > 9 ? "9+" : count}
            </span>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80">
        <DropdownMenuLabel className="flex items-center justify-between">
          <span>Notifikasi</span>
          {count > 0 && (
            <button className="text-xs text-green-700 hover:underline" onClick={markAll} data-testid="notif-mark-all">Tandai semua dibaca</button>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {items.length === 0 && <div className="p-4 text-xs text-center text-neutral-500">Tidak ada notifikasi.</div>}
        {items.map((n) => (
          <DropdownMenuItem key={n.id} onClick={() => n.link && nav(n.link)} className="flex-col items-start gap-0.5 py-2 cursor-pointer">
            <div className="text-xs font-medium">{n.title}</div>
            <div className="text-[11px] text-neutral-500 line-clamp-2">{n.message}</div>
            <div className="text-[10px] text-neutral-400">{formatDateTime(n.created_at)}</div>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => nav("/notifications")} className="text-xs text-green-700 justify-center" data-testid="notif-see-all">
          Lihat Semua
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
